// eslint-disable-next-line import/prefer-default-export
export const ITEM_DB_UPDATE = 'ITEM_DB_UPDATE';

export const ITEM_DB_INFO_REQUEST = 'ITEM_DB_INFO_REQUEST';

export const SET_ITEM_CONFIG = 'SET_ITEM_CONFIG';
